import * as _ from 'lodash';
import { DeliveryNotesService } from '../delivery-notes.service';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../../shared/services/auth.service';

declare const $: any;
let self: any;

@Component({
  selector: 'app-delivery-notes-pdf-modal',
  templateUrl: './delivery-notes-pdf-modal.component.html',
  styleUrls: ['./delivery-notes-pdf-modal.component.css']
})
export class DeliveryNotesPDFModalComponent implements OnInit {
  document: any | string;
  dialog: MatDialogRef<any>;
  isDev!: boolean;
  src!: any;
  fileNameDownload: string = '';

  constructor(
    private _DeliveryNotesService: DeliveryNotesService,
    public dialogRef: MatDialogRef<any>,
    private _AuthService: AuthService,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.loadPDF();
  }

  async loadPDF(): Promise<void> {
    const id = (typeof this.document == 'string') ? this.document : this.document._id;
    const file = await this._DeliveryNotesService.getDeliveryNotePDF(id);
    this.src = file;
    this.fileNameDownload = `Albarán ${this.document.serieAndNumber} de ${this._AuthService.company().name} - Fecha ${this.document.date.substr(0, 10)}`;
  }
}